module.exports = __webpack_public_path__ + "static/img/home_3.14b4ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_3.png
// module id = kbTp
// module chunks = 0